module.exports = __webpack_public_path__ + "static/mediation_unten_cropped-bad34bb40b4d91de2e816f3b5d22c052.jpg";